import React, { useState } from "react";
import liracrypt from "../../components/Liracrypt/liracrypt";
import { Form, Row, Col, Modal, notification, Input } from "antd";
import moment from "moment";
import Date from "../../components/ReportFormGenerator/Date/Date";
import Idame from "../../components/ReportFormGenerator/Idame/Idame";
import CropDown from "../../components/ReportFormGenerator/CropDown/CropDown";
import Radio from "../../components/ReportFormGenerator/Radio/Radio";
import TextBox from "../../components/ReportFormGenerator/TextBox/TextBox";
import Int from "../../components/ReportFormGenerator/Int/Int";
import Decimal from "../../components/ReportFormGenerator/Decimal/Decimal";
import Range from "../../components/ReportFormGenerator/Range/Range";
import TypSubType from "../../components/ReportFormGenerator/TypSubType/TypSubType";
// import UniDrop from "../../components/ReportFormGenerator/UniDrop/UniDrop";
import UniDropAdv from "../../components/ReportFormGenerator/UniDrop/UniDropAdv";
import TypSubTypeDynamic from "../../components/ReportFormGenerator/TypSubType/TypSubTypeDynamic";
import ImgUpload from "./ImgUpload";
import FileController from "./FileController";
import Time from "../../components/ReportFormGenerator/Date/Time";
import ImageSniper from "./ImageSniper";
import BooleanDrop from "../../components/ReportFormGenerator/UniDrop/BooleanDrop";
import SparkTable from "./SparkTable";
import JsonEditor from 'react-json-editor-ui'
import 'react-json-editor-ui/dist/react-json-editor-ui.cjs.development.css'
import CheckboxPicker from "../../components/ReportFormGenerator/Checkbox/Checkbox";
import GilDropdown from "../../components/ReportFormGenerator/GilDropdown";
import StSerialBlock from "./StSerialBlock";
import MultiDropdownTree from "../../components/ReportFormGenerator/MultiDropdownTree";

const InputIdentify = ({
  layoutPosition = "center",
  form,
  name,
  pname,
  label,
  defaultValue = "",
  typ,
  disabled,
  source,
  sourceParams,
  auxParams,
  key,
  format,
  errorMessage,
  required,
  placeHolder,
  options,
  defaultFrom,
  defaultTo,
  data,
  isIST,
  url,
  colSpan,
  includeAll,
  children,
  LocalDict,
  extraData,
  multiSelect,
  modalData,
  modalKey,
  searchable,
  height = '100%',
  rowData
}) => {
  // console.log(defaultValue);
  // if (typ === "datePicker" || typ === "dateTimePicker") {
  //   dateSets[name] = format;
  // }
  let DefaultFrom = moment().format(format);
  let DefaultTo = moment().format(format);
  if (typ === "rangePicker" && data) {
    if (data["defaultFrom"]) {
      DefaultFrom = moment().add(data["defaultFrom"], "days").format(format);
    }
    if (data["defaultTo"] && data) {
      DefaultTo = moment().add(data["defaultTo"], "days").format(format);
    }
  }

  const { TextArea } = Input;



  if (modalData && modalKey) {
    if (!defaultValue) {
      defaultValue = modalData[modalKey];
    }
  }


  return (
    <>
      {typ === "datePicker" ? (
        <>
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 12}>
              <Date
                name={name}
                form={form}
                label={label}
                format={format}
                required={required}
                disabled={disabled}
                defaultValue={
                  modalData && modalKey
                    ? moment(modalData[modalKey]).format(format)
                    : defaultValue?.toString()
                      ? moment().add(defaultValue, 'days').format(format)
                      : ""
                }
                errorMessage={
                  errorMessage ? errorMessage : "Please Select " + label
                }
                placeholder={placeHolder}
                isIST={isIST ? isIST : false}
              />
            </Col>
          </Row>
        </>
      ) : (
        <></>
      )}
      {typ === "rangePicker" ? (
        <Row gutter={24} justify={layoutPosition} key={key}>
          <Col span={colSpan ? colSpan : 12}>
            <Range
              form={form}
              minDate={data.minDate}
              maxDate={data.maxDate}
              placeholder={placeHolder}
              errorMessage={
                errorMessage ? errorMessage : "Please Select " + label
              }
              disabled={disabled ? disabled : false}
              required={required}
              name={name}
              format={format}
              label={label}
              isIST={isIST ? isIST : false}
              defaultValue={
                modalData && modalKey
                  ? [
                    moment(defaultFrom).format(format),
                    moment(defaultTo).format(format),
                  ]
                  : DefaultFrom || DefaultTo
                    ? [
                      DefaultFrom
                        ? DefaultFrom
                        : "",
                      DefaultTo
                        ? DefaultTo
                        : "",
                    ]
                    : null
              }
            />
          </Col>
        </Row>
      ) : (
        <></>
      )}

      {typ === "invisibleControl" ? (
        <>
          <Form.Item
            hidden
            name={name}
            initialValue={defaultValue}
          />
        </>
      ) : (
        <></>
      )}

      {typ === "imageControl" ? (
        <Row gutter={24} justify={layoutPosition} key={key}>
          <Col span={colSpan ? colSpan : 12}>
            <ImageSniper rowData={rowData} height={height} name={name} label={label} data={data} form={form} required={required} disabled={disabled} />
            {/* <ImgUpload rowData={rowData} height={height} name={name} label={label} data={data} form={form} required={required} disabled={disabled} /> */}
          </Col>
        </Row >
      ) : (
        <></>
      )}
      {
        typ === "fileControl" ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 12}>
              <FileController rowData={rowData} height={height} name={name} label={label} data={data} form={form} required={required} disabled={disabled} />
            </Col>
          </Row>
        ) : (
          <></>
        )
      }
      {
        typ === "dateTimePicker" ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 12}>
              <Date
                name={name}
                label={label}
                form={form}
                required={required}
                isIST={isIST ? isIST : false}
                disabled={disabled}
                showTime={true}
                defaultValue={
                  modalData && modalKey
                    ? moment(modalData[modalKey]).format(format)
                    : defaultValue?.toString()
                      ? moment().add(defaultValue, 'days').format(format)
                      : ""
                }
                errorMessage={
                  errorMessage ? errorMessage : "Please Select " + label
                }
                placeholder={placeHolder}
                format={format ? format : "YYYY/MM/DD"}
              />
            </Col>
          </Row>
        ) : (
          <></>
        )
      }
      {typ === "timePicker" ? (
        <Row gutter={24} justify={layoutPosition}>
          <Col span={colSpan ? colSpan : 24}>
            <Time
              name={name}
              label={label}
              form={form}
              required={required}
              isIST={isIST ? isIST : false}
              disabled={disabled}
              showTime={true}
              defaultValue={defaultValue ? defaultValue : ''}
              errorMessage={
                errorMessage ? errorMessage : "Please Select " + label
              }
              placeholder={placeHolder}
            />
          </Col>
        </Row>
      ) : (
        <></>
      )}
      {
        typ === "TypSubTyp" ? (
          <>
            <Row gutter={24} justify={layoutPosition}>
              <Col span={colSpan ? colSpan : 12}>
                <TypSubType
                  //  labelCol={labelColSpan ? labelColSpan : 8}
                  typDefault={auxParams?.typDefault}
                  subTypDefault={auxParams?.subTypDefault}
                  form={form}
                  url={"/" + source}
                  urlData={sourceParams}
                  typName={
                    auxParams?.typ_data_index ? auxParams["typ_data_index"] : "typ_data_index"
                  }
                  typLabel={
                    auxParams?.typLabel ? auxParams["typLabel"] : "typLabel"
                  }
                  typErrorMessage={
                    "Please Enter " + auxParams?.typLabel
                      ? auxParams?.typLabel
                      : "Type"
                  }
                  typRequired={auxParams?.typRequired}
                  typPlaceholder={`Select ${auxParams?.typLabel ? auxParams["typLabel"] : "typLabel"
                    }`}


                  subTypName={
                    auxParams?.subTyp_data_index
                      ? auxParams["subTyp_data_index"]
                      : "subTyp_data_index"
                  }
                  subTypMultiSelect={
                    auxParams?.subTypMultiSelect
                  }
                  subTypLabel={
                    auxParams?.subTypLabel
                      ? auxParams["subTypLabel"]
                      : "subTypLabel"
                  }
                  subTypErrorMessage={
                    "Please Enter " + auxParams?.subTypLabel
                      ? auxParams?.subTypErrorMessage
                      : "subTypErrorMessage"
                  }
                  subTypRequired={auxParams?.subTypRequired}
                  subTypPlaceholder={`Select ${auxParams?.subTypLabel
                    ? auxParams["subTypLabel"]
                    : "subTypLabel"
                    }`}
                  typDisabled={auxParams?.typReadOnly}
                  subTypSearchable={auxParams?.subTypSearchable}
                  typSearchable={auxParams?.typSearchable}
                  subTypDisabled={auxParams?.subTypReadOnly}
                  includeAllTyp={auxParams?.typIncludeAll ? auxParams["typIncludeAll"] : false}
                  includeAllSubTyp={auxParams?.subTypIncludeAll ? auxParams["subTypIncludeAll"] : false}
                />
              </Col>
            </Row>
          </>
        ) : (
          <></>
        )
      }
      {
        typ === 'TypSubTypDynamic' ? (
          <>
            <Row gutter={24} justify={layoutPosition}>
              <Col span={colSpan ? colSpan : 12}>
                <TypSubTypeDynamic
                  typDefault={auxParams?.typDefault}
                  subTypDefault={auxParams?.subTypDefault}
                  //  labelCol={labelColSpan ? labelColSpan : 8}
                  form={form}
                  auxParams={auxParams}
                  subTypSearchable={auxParams?.subTypSearchable}
                  typSearchable={auxParams?.typSearchable}
                  subTypDisabled={auxParams.subTypReadOnly}
                  typDisabled={auxParams.typReadOnly}
                  typName={
                    auxParams["typ_data_index"] ? auxParams["typ_data_index"] : "typName"
                  }
                  typPname={
                    auxParams["typ_data_index"] ? `p_${auxParams["typ_data_index"]}` : "typName"
                  }
                  typLabel={
                    auxParams["typLabel"] ? auxParams["typLabel"] : "typLabel"
                  }
                  typErrorMessage={
                    "Please Enter " + auxParams["typLabel"]
                      ? auxParams["typLabel"]
                      : "Type"
                  }
                  typRequired={auxParams["typRequired"]}
                  typPlaceholder={`Select ${auxParams["typLabel"] ? auxParams["typLabel"] : "typLabel"
                    }`}


                  subTypName={
                    auxParams["subTyp_data_index"]
                      ? auxParams["subTyp_data_index"]
                      : "subTypName"
                  }
                  subTypPname={
                    auxParams["subTyp_data_index"]
                      ? `p_${auxParams["subTyp_data_index"]}`
                      : "p_subTypName"
                  }
                  subTypLabel={
                    auxParams["subTypLabel"]
                      ? auxParams["subTypLabel"]
                      : "subTypLabel"
                  }
                  subTypErrorMessage={
                    "Please Enter " + auxParams["subTypLabel"]
                      ? auxParams["subTypErrorMessage"]
                      : "subTypErrorMessage"
                  }
                  subTypRequired={auxParams["subTypRequired"]}
                  subTypPlaceholder={`Select ${auxParams["subTypLabel"]
                    ? auxParams["subTypLabel"]
                    : "subTypLabel"
                    }`}
                  //    disabled={disabled}
                  includeAllTyp={auxParams["typIncludeAll"] ? auxParams["typIncludeAll"] : false}
                  typMultiSelect={auxParams["typMultiSelect"] ? auxParams["typMultiSelect"] : false}
                  subTypMultiSelect={auxParams["subTypMultiSelect"] ? auxParams["subTypMultiSelect"] : false}
                  includeAllSubTyp={auxParams["subTypIncludeAll"] ? auxParams["subTypIncludeAll"] : false}
                />
              </Col>
            </Row>
          </>
        ) : <></>
      }
      {
        typ === "radio" ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 12}>
              <Radio
                form={form}
                name={name}
                // labelColSpan={16}
                label={label}
                disabled={disabled}
                required={required}
                defaultValue={defaultValue}
                options={options ? Object.keys(options).map(x => {
                  return { label: options[x], value: x }
                }) : [
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
                onChangeConfMsg={data.onChangeConfMsg}
                errorMessage={
                  errorMessage ? errorMessage : "Please Select " + label
                }
              />
            </Col>
          </Row>
        ) : (
          <></>
        )
      }
      {
        typ === 'boolean' ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 12}>
              <BooleanDrop
                placeHolder={placeHolder}
                name={name}
                disabled={disabled}
                errorMessage={errorMessage}
                label={label}
                pnam={`p_${name}`}
                required={required}
                form={form}
                defaultValue={defaultValue}
              />
            </Col>
          </Row>
        ) : <></>
      }
      {
        typ === 'SparkTable' ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 12}>
              <SparkTable
                form={form}
                colSpan={colSpan ? colSpan : 12}
                layoutPosition={layoutPosition}
              />
            </Col>
          </Row>
        ) : <></>
      }
      {
        typ === "textBox" ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 12}>
              <TextBox
                form={form}
                type={data.rows ? "textArea" : "input"}
                name={name}
                label={label}
                disabled={disabled}
                required={required}
                errorMessage={
                  errorMessage ? errorMessage : "Please Enter " + label
                }
                defaultValue={defaultValue ? defaultValue : null}
                placeholder={placeHolder}
              //   maxChar={400}
              //   maxCharErrorMessage="Accepted only 400 Chars"
              />
            </Col>
          </Row>
        ) : (
          <></>
        )
      }

      {
        typ === "textArea" ? (
          <>
            <Row gutter={24} justify={layoutPosition} key={key}>
              <Col span={colSpan ? colSpan : 12} style={{ marginBottom: "10px" }}>
                <TextArea
                  value={defaultValue ? defaultValue : ""}
                  rows={2}
                  disabled={disabled ? disabled : false}
                  placeholder={placeHolder}
                />
              </Col>
            </Row>
          </>
        ) : (
          <></>
        )
      }

      {
        typ === "intControl" ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 12}>
              <Int
                min={data.min}
                max={data.max}
                form={form}
                name={name}
                label={label}
                disabled={disabled}
                required={required}
                errorMessage={
                  errorMessage ? errorMessage : "Please Enter " + label
                }
                defaultValue={defaultValue}
              />
            </Col>
          </Row>
        ) : (
          <></>
        )
      }

      {
        typ === "decimalControl" ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 12}>
              <Decimal
                min={data.min}
                max={data.max}
                form={form}
                name={name}
                label={label}
                disabled={disabled}
                defaultValue={defaultValue}
                errorMessage={
                  errorMessage ? errorMessage : "Please Enter " + label
                }
                required={required}
              />
            </Col>
          </Row>
        ) : (
          <></>
        )
      }
      {
        typ === 'json' ?
          <JsonEditor
            data={defaultValue || {}}
            width={350}
            onChange={data => {
              console.log(data);
            }}
          /> : <></>
      }
      {
        typ === 'gilDropdown' ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 24}>
              <GilDropdown
                LocalDict={LocalDict}
                name={name}
                label={label}
                form={form}
                required={required}
                disabled={disabled}
                errorMessage={
                  errorMessage ? errorMessage : "Please Select " + label
                }
                options={options ? Object.keys(options).map(x => {
                  return { label: options[x], value: x }
                }) : [
                  { label: 'Yes', value: 'yes' },
                  { label: 'No', value: 'no' },
                ]}
                children={data.children || {}}
                defaultValue={defaultValue?.toString() ? defaultValue?.toString() : null}
              />
            </Col>
          </Row>
        ) : <></>
      }
      {
        typ === 'multiLevelDropdown' ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            <Col span={colSpan ? colSpan : 24}>
              <MultiDropdownTree
                form={form}
                elements={data.elements}
                extraData={extraData}
                data={data}
              />
            </Col>
          </Row>
        ) : <></>
      }
      {typ === "checkbox" ? (
        <Row gutter={24} justify={layoutPosition} key={key}>
          <Col span={colSpan ? colSpan : 24}>
            <CheckboxPicker
              form={form}
              name={name}
              disabled={disabled}
              required={required}
              defaultValue={defaultValue}
              options={options ? Object.keys(options).map(x => {
                return { label: options[x], value: x }
              }) : [
                { label: 'Yes', value: 'yes' },
                { label: 'No', value: 'no' },
              ]}
              label={label}
              onChange={(value) => { }}
              errorMessage={errorMessage ? errorMessage : "Please Select " + label}
            />

          </Col>
        </Row>
      ) : (
        <></>
      )}
      {typ === "serialBlock" ? (
        <Row gutter={24} justify={layoutPosition} key={key}>
          <Col span={colSpan ? colSpan : 24}>
            <StSerialBlock
              options={options}
              submitOnClick={data.submitOnClick}
              name={name}
              form={form}
              data={data}
              defaultValue={defaultValue}
              label={label}
              required={required}
              disabled={disabled}
              errorMessage={
                errorMessage ? errorMessage : "Please Enter " + label
              }
            />

          </Col>
        </Row>
      ) : (
        <></>
      )}

      {
        typ === "dropDown" ? (
          <Row gutter={24} justify={layoutPosition} key={key}>
            {source === "mdict" ||
              source === "usergroup" ||
              source === "cropdown" ||
              source === "data" ||
              source === "dynamic" ||
              source === "dynamicSearch"
              ? (
                <Col span={colSpan ? colSpan : 12}>
                  <UniDropAdv
                    minSearchLength={data.minSearchLength || 3}
                    form={form}
                    colSpan={colSpan ? colSpan : 12}
                    multiSelect={multiSelect}
                    url={
                      url
                        ? url
                        : source === "mdict"
                          ? "/mdict"
                          : source === "usergroup"
                            ? "/usergroup"
                            : source === "cropdown"
                              ? "/cropdown"
                              : source === "dynamic"
                                ? "/dynamicdropdown"
                                : ""
                    }
                    disabled={disabled}
                    allowClear={data.allowClear}
                    source={source}
                    options={options}
                    onChangeConfMsg={data.onChangeConfMsg}
                    extraData={extraData}
                    urlData={sourceParams ? sourceParams : {}}
                    pname={pname ? pname : `p_${name}`}
                    name={name}
                    label={label}
                    errorMessage={"Please Select " + label}
                    required={required}
                    placeholder={placeHolder}
                    defaultValue={defaultValue ? defaultValue : null}
                    includeAll={includeAll ? includeAll : false}
                    searchable={searchable ? searchable : false}
                  />
                </Col>
              ) : (
                <></>
              )}
          </Row>
        ) : (
          <></>
        )
      }
    </>
  );
};
export default InputIdentify;
